import {
    CartItemInterface,
    SimpleCartItem,
    Maybe
} from '@pylot-data/pylotschema'

export const useCartItemsCount = (
    items: Maybe<Maybe<CartItemInterface>[]> | undefined
): number => {
    if (!items) {
        return 0
    }

    return items?.reduce((itemCount, item) => {
        if (item) {
            return itemCount + (item as SimpleCartItem)?.quantity
        }
        // Return 0 to make the itemCount unchanged and prevent NAN return type
        return 0
    }, 0)
}
